export default __webpack_public_path__ + "static/media/hht1_ep16_minisitcom_02.4cc37f63.png";